import { gql } from "@apollo/client";

export const CREATE_MATERIAL = gql`
  mutation CreateMaterial($input: MaterialInput) {
    createMaterial(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_MATERIAL_IS_USE = gql`
  mutation UpdateMaterialIsUse($id: ID!, $isUse: Boolean) {
    updateMaterialIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;


export const GET_LIST_MATERIAL_UNIT_PAGINATION = gql`
  query GetListMaterialUnitPagination($page: Int, $limit: Int, $pagination: Boolean, $keyword: String, $isUse: Boolean, $categoryId: ID, $groupId: ID, $sectionId: ID, $levelSectionId: ID, $sizeId: ID) {
    getListMaterialUnitPagination(page: $page, limit: $limit, pagination: $pagination, keyword: $keyword, isUse: $isUse, categoryId: $categoryId, groupId: $groupId, sectionId: $sectionId, levelSectionId: $levelSectionId, sizeId: $sizeId) {
      data {
        _id
        materialId {
          _id
          materialEnName
          materialKhName
          sizeId {
            _id
            sizeEnName
            sizeKhName
          }
          levelSectionId {
            _id
            levelSectionEnName
            levelSectionKhName
          }
          groupId {
            _id
            groupEnName
            groupKhName
          }
          categoryId {
            categoryEnName
            categoryKhName
            _id
          }
        }
        imageSrc
        unitId {
          _id
          unitKhName
          unitEnName
          isUse
        }
        qtyInUnit
        costPerUnit
        barcode
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`



export const GET_MATERIAL_PAGINATION = gql`
  query GetMaterialPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
    $categoryId: ID
    $groupId: ID
    $sectionId: ID
    $levelSectionId: ID
    $sizeId: ID
  ) {
    getMaterialPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
      categoryId: $categoryId
      groupId: $groupId
      sectionId: $sectionId
      levelSectionId: $levelSectionId
      sizeId: $sizeId
    ) {
      data {
        _id
        materialKhName
        materialEnName
        isbm
        categoryId {
          _id
          categoryEnName
          categoryKhName
        }
        sectionId {
          _id
          sectionEnName
          sectionKhName
        }
        levelSectionId {
          _id
          levelSectionEnName
          levelSectionKhName
        }
        groupId {
          _id
          groupEnName
          groupKhName
        }
        smallUnitId {
          _id
          unitEnName
          unitKhName
        }
        sizeId {
          _id
          sizeEnName
          sizeKhName
        }
        defaultPrice
        isUse
        remark
        isLongTerm
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_MATERIAL = gql`
  mutation UpdateMaterial($id: ID!, $input: MaterialInput) {
    updateMaterial(_id: $id, input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const DELETE_MATERIAL = gql`
  mutation DeleteMaterial($id: ID!) {
    deleteMaterial(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;


export const SELECT_MATERIAL = gql`
  query SelectMaterial($sectionId: ID, $groupId: ID, $isUse: Boolean) {
    selectMaterial(sectionId: $sectionId, groupId: $groupId, isUse: $isUse) {
      _id
      materialEnName
      materialKhName
      isbm
      sizeId {
        sizeEnName
        sizeKhName
      }
      groupId {
        groupEnName
        groupKhName
      }
      smallUnitId {
        unitEnName
        unitKhName
      }
      isLongTerm
    }
  }
`;

export const SELECT_MATERIAL_BY_WAREHOUSEID = gql`
  query SelectMaterialByWarehouse($warehouseId: ID) {
    selectMaterialByWarehouse(warehouseId: $warehouseId) {
      _id
      materialKhName
      materialEnName
      sizeId {
        _id
        sizeEnName
        sizeKhName
      }
    }
  }
`;
